'use strict';
define(['xlsx', 'components/st-keyword-trend/history-trend-bars'], function (XLSX, buildHistoryTrendBars) {
    function Controller(
        $scope,
        $q,
        $timeout,
        $filter,
        $window,
        $state,
        $stateParams,
        KeywordListService,
        UserService,
        LanguageService
    ) {
        var vm = $scope;
        var DEFAULT_COUNTRY = 'IT';
        var REFRESH_CHUNK_SIZE = 100;
        var COUNTRIES = [
            {code: 'IT', name: 'Italia', locationId: '2380', languageId: '1004'},
            {code: 'US', name: 'Stati Uniti', locationId: '2840', languageId: '1000'},
            {code: 'GB', name: 'Regno Unito', locationId: '2826', languageId: '1000'},
            {code: 'DE', name: 'Germania', locationId: '2276', languageId: '1001'},
            {code: 'FR', name: 'Francia', locationId: '2250', languageId: '1002'},
            {code: 'ES', name: 'Spagna', locationId: '2724', languageId: '1003'},
            {code: 'PT', name: 'Portogallo', locationId: '2620', languageId: '1000'},
            {code: 'NL', name: 'Paesi Bassi', locationId: '2528', languageId: '1000'},
            {code: 'BE', name: 'Belgio', locationId: '2056', languageId: '1000'},
            {code: 'CH', name: 'Svizzera', locationId: '2756', languageId: '1001'},
            {code: 'AT', name: 'Austria', locationId: '2040', languageId: '1001'},
            {code: 'IE', name: 'Irlanda', locationId: '2372', languageId: '1000'},
            {code: 'SE', name: 'Svezia', locationId: '2752', languageId: '1000'},
            {code: 'NO', name: 'Norvegia', locationId: '2578', languageId: '1000'},
            {code: 'DK', name: 'Danimarca', locationId: '2208', languageId: '1000'},
            {code: 'FI', name: 'Finlandia', locationId: '2246', languageId: '1000'},
            {code: 'PL', name: 'Polonia', locationId: '2616', languageId: '1000'},
            {code: 'CZ', name: 'Repubblica Ceca', locationId: '2203', languageId: '1000'},
            {code: 'GR', name: 'Grecia', locationId: '2300', languageId: '1000'},
            {code: 'RO', name: 'Romania', locationId: '2642', languageId: '1000'},
            {code: 'HU', name: 'Ungheria', locationId: '2348', languageId: '1000'},
            {code: 'CA', name: 'Canada', locationId: '2124', languageId: '1000'},
            {code: 'MX', name: 'Messico', locationId: '2484', languageId: '1003'},
            {code: 'BR', name: 'Brasile', locationId: '2076', languageId: '1000'},
            {code: 'AR', name: 'Argentina', locationId: '2032', languageId: '1003'},
            {code: 'AU', name: 'Australia', locationId: '2036', languageId: '1000'},
            {code: 'NZ', name: 'Nuova Zelanda', locationId: '2554', languageId: '1000'},
            {code: 'JP', name: 'Giappone', locationId: '2392', languageId: '1000'},
            {code: 'KR', name: 'Corea del Sud', locationId: '2410', languageId: '1000'},
            {code: 'CN', name: 'Cina', locationId: '2156', languageId: '1000'},
            {code: 'IN', name: 'India', locationId: '2356', languageId: '1000'},
            {code: 'SG', name: 'Singapore', locationId: '2702', languageId: '1000'},
            {code: 'AE', name: 'Emirati Arabi Uniti', locationId: '2784', languageId: '1000'},
            {code: 'TR', name: 'Turchia', locationId: '2792', languageId: '1000'},
            {code: 'ZA', name: 'Sudafrica', locationId: '2710', languageId: '1000'}
        ];

        vm.countries = COUNTRIES;
        vm.country = countryFor(defaultCountryCode());
        vm.loading = true;
        vm.loadingList = false;
        vm.lists = [];
        vm.visibleLists = [];
        vm.moveTargetOptions = [];
        vm.listSearch = '';
        vm.newListName = '';
        vm.selectedListId = null;
        vm.list = null;
        vm.rows = [];
        vm.pageRows = [];
        vm.filteredRows = [];
        vm.search = '';
        vm.filters = {country: '', data: ''};
        vm.filterCountries = [];
        vm.page = 1;
        vm.pageSize = 50;
        vm.pages = 1;
        vm.sort = {field: 'keyword', dir: 1};
        vm.add = {
            keywords: '',
            importedKeywords: null,
            fileName: '',
            mode: 'manual',
            open: false,
            error: '',
            limit: 1000,
            limitReady: false,
            enrich: true,
            busy: false,
            progress: null,
            abort: false
        };
        vm.refresh = {busy: false, progress: null, abort: false};
        vm.notice = null;
        vm.renaming = false;
        vm.renameName = '';
        vm.confirmDeleteList = false;
        vm.moveTargetId = null;
        vm.shareUrl = null;
        vm.exportOpen = false;
        vm.cloneBusy = {};
        vm.countryPickerSearch = '';
        vm.inlineEdit = {id: null, name: '', originalName: ''};
        vm.savingListName = false;

        vm.createList = createList;
        vm.selectList = selectList;
        vm.applyListFilter = applyListFilter;
        vm.addKeywords = addKeywords;
        vm.addCostLabel = addCostLabel;
        vm.openAddKeywords = openAddKeywords;
        vm.closeAddKeywords = closeAddKeywords;
        vm.setAddMode = setAddMode;
        vm.pendingKeywords = pendingKeywords;
        vm.pendingKeywordsPreview = pendingKeywordsPreview;
        vm.hiddenPendingCount = hiddenPendingCount;
        vm.removePendingKeyword = removePendingKeyword;
        vm.addCapacity = addCapacity;
        vm.addIsOverCapacity = addIsOverCapacity;
        vm.addCapacityOverflow = addCapacityOverflow;
        vm.canSubmitAdd = canSubmitAdd;
        vm.ignoredExistingCount = ignoredExistingCount;
        vm.addKeywordCount = function () { return pendingKeywords().length; };
        vm.clearImportedKeywords = clearImportedKeywords;
        vm.countryOptions = countryOptions;
        vm.selectCountry = selectCountry;
        vm.importCsv = importCsv;
        vm.refreshSelected = refreshSelected;
        vm.refreshOne = refreshOne;
        vm.deleteSelected = deleteSelected;
        vm.deleteOne = deleteOne;
        vm.moveSelected = moveSelected;
        vm.exportCsv = exportCsv;
        vm.exportXlsx = exportXlsx;
        vm.exportTo = exportTo;
        vm.copyKeywords = copyKeywords;
        vm.startRename = startRename;
        vm.saveRename = saveRename;
        vm.cancelRename = cancelRename;
        vm.deleteList = deleteList;
        vm.cloneList = cloneList;
        vm.renameListFromMenu = renameListFromMenu;
        vm.saveInlineListName = saveInlineListName;
        vm.cancelInlineEdit = cancelInlineEdit;
        vm.deleteListFromMenu = deleteListFromMenu;
        vm.shareList = shareList;
        vm.copyShareUrl = copyShareUrl;
        vm.applyFilters = applyFilters;
        vm.setSort = setSort;
        vm.setPage = setPage;
        vm.isPageSelected = isPageSelected;
        vm.isPageIndeterminate = isPageIndeterminate;
        vm.togglePageSelection = togglePageSelection;
        vm.selectAllFiltered = selectAllFiltered;
        vm.clearSelection = clearSelection;
        vm.allFilteredSelected = allFilteredSelected;
        vm.selectedCount = selectedCount;
        vm.selectionChanged = selectionChanged;
        vm.clearFilters = clearFilters;
        vm.hasActiveFilters = hasActiveFilters;
        vm.activeFiltersCount = activeFiltersCount;
        vm.toggleExportMenu = toggleExportMenu;
        vm.closeExportMenu = closeExportMenu;
        vm.formatVolume = formatVolume;
        vm.formatMetric = formatMetric;
        vm.formatCpc = formatCpc;
        vm.formatDate = formatDate;
        vm.kdClass = kdClass;
        vm.hasData = hasData;
        vm.hasMetric = hasMetric;

        loadKeywordLimit();
        loadLists();

        function defaultCountryCode() {
            var current = LanguageService.getCodeAndCountrySaveOnStorage() || '';
            var code = String(current).split('-')[1] || String(current).slice(0, 2);
            code = code.toUpperCase();
            return COUNTRIES.some(function (item) { return item.code === code; }) ? code : DEFAULT_COUNTRY;
        }

        function countryFor(code) {
            var normalized = String(code || '').toUpperCase();
            return COUNTRIES.filter(function (item) { return item.code === normalized; })[0]
                || {
                    code: normalized || DEFAULT_COUNTRY,
                    name: normalized || DEFAULT_COUNTRY,
                    locationId: null,
                    languageId: null
                };
        }

        function bodyData(response) {
            return response && response.data !== undefined ? response.data : response;
        }

        function errorMessage(error) {
            return (error && error.data && error.data.error && error.data.error.message)
                || (error && error.error && error.error.message)
                || (error && error.message)
                || 'Operazione non riuscita.';
        }

        function loadKeywordLimit() {
            vm.add.limitReady = false;
            UserService.limits(true).then(function (response) {
                var limits = response && response.data && response.data.limits || [];
                var service = limits.filter(function (item) {
                    return item.alias === 'keyword-list-manager-queries';
                })[0];
                vm.add.limit = service ? Math.max(0, Number(service.qtyAllowed) || 0) : 1000;
            }).catch(function () {
                vm.add.limit = 1000;
            }).finally(function () {
                vm.add.limitReady = true;
            });
        }

        function showNotice(type, text) {
            vm.notice = {type: type, text: text};
            $timeout(function () {
                if (vm.notice && vm.notice.text === text) {
                    vm.notice = null;
                }
            }, 6000);
        }

        function loadLists(selectId) {
            vm.loading = true;
            return KeywordListService.getAllKeywordList()
                .then(function (response) {
                    var data = bodyData(response) || {};
                    vm.lists = data.rows || [];
                    applyListFilter();
                    refreshMoveTargets();
                    var requestedId = selectId
                        || $stateParams.keywordListId
                        || listIdFromPath()
                        || vm.selectedListId;
                    var requestedExists = vm.lists.some(function (item) {
                        return Number(item.keywordListId) === Number(requestedId);
                    });
                    var id = requestedExists
                        ? requestedId
                        : (vm.lists[0] && vm.lists[0].keywordListId);
                    if (id) {
                        return loadList(id);
                    }
                    syncListRoute(null);
                    vm.list = null;
                    vm.rows = [];
                    vm.pageRows = [];
                    return null;
                })
                .catch(function (error) {
                    showNotice('error', errorMessage(error));
                })
                .finally(function () {
                    vm.loading = false;
                });
        }

        function loadList(id, silent) {
            if (!id) {
                return $q.when();
            }
            var selectedIds = {};
            if (silent) {
                vm.rows.forEach(function (row) {
                    if (row.selected) {
                        selectedIds[String(row.id)] = true;
                    }
                });
            }
            vm.selectedListId = Number(id);
            syncListRoute(id);
            if (!silent) {
                vm.loadingList = true;
                vm.list = null;
                vm.rows = [];
                vm.pageRows = [];
                vm.filteredRows = [];
                vm.clearSelection();
            }
            return KeywordListService.getOneKeywordList(id)
                .then(function (response) {
                    var data = bodyData(response) || {};
                    vm.selectedListId = Number(id);
                    vm.list = {
                        id: Number(id),
                        name: data.keywordListName,
                        token: data.tokenKeywordList,
                        totalVolume: data.totalVolume,
                        averageCPC: data.averageCPC,
                        averageDifficulty: data.averageDifficulty,
                        queries: (data.queries && data.queries.rows) || []
                    };
                    vm.rows = vm.list.queries.map(function (row) {
                        row.selected = !!selectedIds[String(row.id)];
                        row.refreshing = false;
                        row.trendBars = buildHistoryTrendBars(row);
                        return row;
                    });
                    if (!silent) {
                        vm.page = 1;
                        vm.shareUrl = null;
                        vm.moveTargetId = null;
                        vm.filters = {country: '', data: ''};
                    }
                    refreshFilterCountries();
                    refreshMoveTargets();
                    applyFilters();
                    if (String($stateParams.add || '') === '1'
                        || /(?:^|[?&])add=1(?:&|$)/.test($window.location.search)) {
                        openAddKeywords();
                        $stateParams.add = null;
                        $window.history.replaceState(
                            $window.history.state,
                            '',
                            $window.location.pathname
                        );
                    }
                })
                .catch(function (error) {
                    showNotice('error', errorMessage(error));
                })
                .finally(function () {
                    if (!silent) {
                        vm.loadingList = false;
                    }
                });
        }

        function selectList(id) {
            if (!id || Number(id) === Number(vm.selectedListId)) {
                return;
            }
            vm.selectedListId = Number(id);
            syncListRoute(id);
            vm.renaming = false;
            vm.confirmDeleteList = false;
            closeAddKeywords(true);
            loadList(id);
        }

        function syncListRoute(id) {
            var target = id
                ? 'app.keywordlistmanager.v2list'
                : 'app.keywordlistmanager.v2';
            var currentId = $state.params && $state.params.keywordListId;
            var routeChanged = $state.current.name !== target
                || (id && Number(currentId) !== Number(id));
            if (routeChanged) {
                $state.go(target, id ? {keywordListId: id} : {}, {
                    location: 'replace'
                });
            }
        }

        function listIdFromPath() {
            var match = String($window.location.pathname || '')
                .match(/\/keyword-list-manager\/list\/(\d+)\/?$/);
            return match ? match[1] : null;
        }

        function applyListFilter() {
            var term = String(vm.listSearch || '').trim().toLowerCase();
            vm.visibleLists = !term ? vm.lists : vm.lists.filter(function (item) {
                return String(item.keywordListName || '').toLowerCase().indexOf(term) !== -1;
            });
        }

        function refreshFilterCountries() {
            var counts = {};
            vm.rows.forEach(function (row) {
                var code = String(row.countryCode || '').toUpperCase();
                if (code) {
                    counts[code] = (counts[code] || 0) + 1;
                }
            });
            vm.filterCountries = Object.keys(counts).sort().map(function (code) {
                var item = countryFor(code);
                return {code: code, name: item.name, count: counts[code]};
            });
        }

        function parseKeywords() {
            var seen = {};
            return String(vm.add.keywords || '')
                .split(/[\n,;]+/)
                .map(function (keyword) { return keyword.trim(); })
                .filter(function (keyword) {
                    var key = keyword.toLowerCase();
                    if (!keyword || seen[key]) {
                        return false;
                    }
                    seen[key] = true;
                    return true;
                });
        }

        function parsedAddKeywords() {
            return Array.isArray(vm.add.importedKeywords)
                ? vm.add.importedKeywords
                : parseKeywords();
        }

        function addKeywordKey(keyword, countryCode) {
            return String(keyword || '').trim().toLowerCase()
                + '\u0000' + String(countryCode || '').toUpperCase();
        }

        function pendingKeywords() {
            var existing = {};
            vm.rows.forEach(function (row) {
                existing[addKeywordKey(row.keyword, row.countryCode)] = true;
            });
            return parsedAddKeywords().filter(function (keyword) {
                return !existing[addKeywordKey(keyword, vm.country && vm.country.code)];
            });
        }

        function pendingKeywordsPreview() {
            return pendingKeywords().slice(0, 20);
        }

        function hiddenPendingCount() {
            return Math.max(0, pendingKeywords().length - 20);
        }

        function addKeywordsToProcess() {
            return pendingKeywords();
        }

        function ignoredExistingCount() {
            return Math.max(0, parsedAddKeywords().length - pendingKeywords().length);
        }

        function addCapacity() {
            if (!vm.add.limitReady) {
                return 0;
            }
            return Math.max(0, vm.add.limit - vm.rows.length);
        }

        function addIsOverCapacity() {
            return vm.add.limitReady && pendingKeywords().length > addCapacity();
        }

        function addCapacityOverflow() {
            return Math.max(0, pendingKeywords().length - addCapacity());
        }

        function canSubmitAdd() {
            var count = pendingKeywords().length;
            return !!vm.list && vm.add.limitReady && !vm.add.busy
                && count > 0 && count <= addCapacity();
        }

        function removePendingKeyword(keyword) {
            var key = String(keyword || '').trim().toLowerCase();
            var remaining = parsedAddKeywords().filter(function (item) {
                return String(item || '').trim().toLowerCase() !== key;
            });
            vm.add.keywords = remaining.join('\n');
            vm.add.importedKeywords = remaining.length ? remaining : null;
            if (!remaining.length) {
                vm.add.fileName = '';
            }
            vm.add.error = '';
        }

        function clearImportedKeywords() {
            vm.add.importedKeywords = null;
            vm.add.fileName = '';
            vm.add.error = '';
        }

        function resetAddDraft() {
            vm.add.keywords = '';
            vm.add.importedKeywords = null;
            vm.add.fileName = '';
            vm.add.mode = 'manual';
            vm.add.error = '';
            vm.add.progress = null;
        }

        function openAddKeywords() {
            if (!vm.list) {
                return;
            }
            vm.add.open = true;
            vm.add.error = '';
        }

        function closeAddKeywords(force) {
            if (vm.add.busy && !force) {
                return;
            }
            vm.add.open = false;
            if (!vm.add.busy) {
                resetAddDraft();
            }
        }

        function setAddMode(mode) {
            if (mode !== 'manual' && mode !== 'csv') {
                return;
            }
            vm.add.mode = mode;
            vm.add.error = '';
        }

        function countryOptions() {
            var term = String(vm.countryPickerSearch || '').trim().toLowerCase();
            return !term ? vm.countries : vm.countries.filter(function (item) {
                return String(item.name || '').toLowerCase().indexOf(term) !== -1
                    || String(item.code || '').toLowerCase().indexOf(term) !== -1;
            });
        }

        function selectCountry(item, event) {
            if (!item) {
                return;
            }
            vm.country = item;
            vm.countryPickerSearch = '';
            var node = event && event.target;
            while (node && node.tagName !== 'DETAILS') {
                node = node.parentNode;
            }
            if (node) {
                node.open = false;
            }
        }

        function importCsv(file, event) {
            if (!file) {
                return;
            }
            vm.add.mode = 'csv';
            vm.add.error = '';
            vm.add.fileName = '';
            vm.add.importedKeywords = null;
            vm.add.keywords = '';
            if (!/\.csv$/i.test(file.name || '')) {
                vm.add.error = 'Seleziona un file CSV.';
                return;
            }
            var reader = new $window.FileReader();
            reader.onload = function (loadEvent) {
                $scope.$applyAsync(function () {
                    var rows = parseCsv(String(loadEvent.target.result || ''));
                    var extracted = keywordsFromCsvRows(rows);
                    if (!extracted.length) {
                        vm.add.error = 'Nessuna keyword trovata nel file CSV.';
                        return;
                    }
                    var truncated = extracted.length > 1000;
                    var keywords = extracted.slice(0, 1000);
                    vm.add.keywords = keywords.join('\n');
                    vm.add.importedKeywords = keywords;
                    vm.add.fileName = file.name;
                    vm.add.error = truncated
                        ? 'Il file contiene più di 1000 keyword: sono state caricate le prime 1000.'
                        : '';
                });
            };
            reader.onerror = function () {
                $scope.$applyAsync(function () {
                    vm.add.error = 'Impossibile leggere il file CSV.';
                });
            };
            reader.readAsText(file, 'UTF-8');
            if (event && event.target) {
                event.target.value = '';
            }
        }

        function parseCsv(text) {
            var content = String(text || '').replace(/^\uFEFF/, '');
            var firstLine = content.split(/\r?\n/)[0] || '';
            var delimiter = (firstLine.match(/;/g) || []).length
                > (firstLine.match(/,/g) || []).length ? ';' : ',';
            var rows = [];
            var row = [];
            var cell = '';
            var quoted = false;

            for (var index = 0; index < content.length; index += 1) {
                var char = content[index];
                if (char === '"') {
                    if (quoted && content[index + 1] === '"') {
                        cell += '"';
                        index += 1;
                    } else {
                        quoted = !quoted;
                    }
                } else if (char === delimiter && !quoted) {
                    row.push(cell);
                    cell = '';
                } else if ((char === '\n' || char === '\r') && !quoted) {
                    if (char === '\r' && content[index + 1] === '\n') {
                        index += 1;
                    }
                    row.push(cell);
                    if (row.some(function (value) { return String(value).trim(); })) {
                        rows.push(row);
                    }
                    row = [];
                    cell = '';
                } else {
                    cell += char;
                }
            }
            row.push(cell);
            if (row.some(function (value) { return String(value).trim(); })) {
                rows.push(row);
            }
            return rows;
        }

        function keywordsFromCsvRows(rows) {
            if (!rows.length) {
                return [];
            }
            var header = rows[0].map(function (value) {
                return String(value || '').trim().toLowerCase();
            });
            var aliases = [
                'keyword', 'keywords', 'query', 'queries', 'term', 'terms',
                'termine', 'termini', 'parola chiave', 'parole chiave'
            ];
            var column = -1;
            header.some(function (value, index) {
                if (aliases.indexOf(value) !== -1) {
                    column = index;
                    return true;
                }
                return false;
            });
            var start = column === -1 ? 0 : 1;
            if (column === -1) {
                column = 0;
            }

            var seen = {};
            return rows.slice(start).map(function (cells) {
                return String(cells[column] || '').trim();
            }).filter(function (keyword) {
                var key = keyword.toLowerCase();
                if (!keyword || seen[key]) {
                    return false;
                }
                seen[key] = true;
                return true;
            });
        }

        function addCostLabel() {
            var count = addKeywordsToProcess().length;
            if (!vm.add.enrich) {
                return count ? 'Aggiungi gratis' : 'Aggiungi';
            }
            return 'Aggiungi' + (count ? ' · ' + count + (count === 1 ? ' credito' : ' crediti') : '');
        }

        function buildQuery(keyword, country) {
            return {
                keyword: keyword,
                countryCode: country.code,
                locationId: country.locationId,
                languageId: country.languageId,
                searchEngineId: 1,
                deviceId: 1
            };
        }

        function addKeywords() {
            var keywords = addKeywordsToProcess();
            if (!keywords.length || !vm.list) {
                return;
            }
            if (!vm.add.limitReady) {
                vm.add.error = 'Sto verificando i limiti del piano. Riprova tra poco.';
                return;
            }
            if (keywords.length > addCapacity()) {
                vm.add.error = 'Puoi aggiungere ancora ' + addCapacity() + ' keyword a questa lista.';
                return;
            }
            vm.add.error = '';
            vm.add.busy = true;
            vm.add.abort = false;
            vm.add.progress = {done: 0, total: keywords.length, keyword: ''};
            var stats = {withData: 0, noData: 0, errors: 0, creditError: false};
            var sequence = $q.when();

            keywords.forEach(function (keyword, index) {
                sequence = sequence.then(function () {
                    if (vm.add.abort) {
                        return null;
                    }
                    vm.add.progress.keyword = keyword;
                    return KeywordListService.addKeywordToList(
                        vm.list.id,
                        buildQuery(keyword, vm.country),
                        vm.add.enrich
                    ).then(function (data) {
                        if (data && data.charged) {
                            stats.withData += 1;
                        } else {
                            stats.noData += 1;
                        }
                    }).catch(function (error) {
                        stats.errors += 1;
                        if (error && error.status === 429) {
                            stats.creditError = true;
                            vm.add.abort = true;
                        }
                    }).finally(function () {
                        vm.add.progress.done = index + 1;
                    });
                });
            });

            sequence.then(function () {
                vm.add.busy = false;
                return loadList(vm.list.id, true);
            }).then(function () {
                var added = stats.withData + stats.noData;
                if (added) {
                    vm.add.open = false;
                    resetAddDraft();
                } else {
                    vm.add.error = stats.creditError
                        ? 'Crediti insufficienti: nessuna keyword è stata aggiunta.'
                        : 'Nessuna keyword è stata aggiunta. Controlla i dati e riprova.';
                }
                if (stats.creditError) {
                    showNotice('warning', 'Crediti analysis insufficienti. Le keyword già aggiunte sono state salvate; puoi aggiungere le altre senza dati.');
                } else {
                    var parts = [];
                    if (stats.withData) parts.push(stats.withData + ' con dati');
                    if (stats.noData) parts.push(stats.noData + ' senza dati');
                    if (stats.errors) parts.push(stats.errors + ' non aggiunte');
                    showNotice(
                        stats.errors ? 'warning' : 'success',
                        'Aggiunta completata: ' + (parts.join(', ') || '0 keyword') + '.'
                    );
                }
            }).catch(function (error) {
                vm.add.busy = false;
                vm.add.error = errorMessage(error);
            });
        }

        function refreshRows(rows) {
            if (!rows.length || !vm.list) {
                return;
            }
            vm.refresh.busy = true;
            vm.refresh.abort = false;
            vm.refresh.progress = {done: 0, total: rows.length};
            rows.forEach(function (row) { row.refreshing = true; });

            var totals = {updated: 0, noData: 0, unsupportedCountries: 0};
            var failure = null;
            var chunks = [];
            for (var start = 0; start < rows.length; start += REFRESH_CHUNK_SIZE) {
                chunks.push(rows.slice(start, start + REFRESH_CHUNK_SIZE));
            }
            var sequence = $q.when();

            chunks.forEach(function (chunk) {
                sequence = sequence.then(function () {
                    if (vm.refresh.abort) {
                        return null;
                    }
                    return KeywordListService.refreshKeywords(
                        vm.list.id,
                        chunk.map(function (row) { return row.id; })
                    ).then(function (data) {
                        totals.updated += Number(data && data.updated) || 0;
                        totals.noData += Number(data && data.noData) || 0;
                        totals.unsupportedCountries += Number(data && data.unsupportedCountries) || 0;
                        var resultsById = {};
                        ((data && data.results) || []).forEach(function (result) {
                            resultsById[String(result.queryId)] = result;
                        });
                        chunk.forEach(function (row) {
                            var result = resultsById[String(row.id)];
                            if (!result) {
                                return;
                            }
                            row.avgVolume = result.avgVolume;
                            row.avgCpc = result.avgCpc;
                            row.avgCompetition = result.avgCompetition;
                            row.avgDifficulty = result.avgDifficulty;
                        });
                        vm.refresh.progress.done += chunk.length;
                    }).catch(function (error) {
                        failure = error;
                        vm.refresh.abort = true;
                    });
                });
            });

            sequence.then(function () {
                rows.forEach(function (row) { row.refreshing = false; });
                vm.refresh.busy = false;
                return loadList(vm.list.id, true);
            }).then(function () {
                if (failure) {
                    var partial = [];
                    if (totals.updated) partial.push(totals.updated + ' aggiornate');
                    if (totals.noData) partial.push(totals.noData + ' senza dati');
                    if (totals.unsupportedCountries) {
                        partial.push(totals.unsupportedCountries + ' con paese non supportato');
                    }
                    var prefix = partial.length ? 'Aggiornamento parziale: ' + partial.join(', ') + '. ' : '';
                    if (failure.status === 429) {
                        showNotice('warning', prefix + 'Crediti analysis insufficienti per completare l’aggiornamento.');
                    } else {
                        showNotice('error', prefix + errorMessage(failure));
                    }
                    return;
                }
                var parts = [];
                if (totals.updated) parts.push(totals.updated + ' aggiornate');
                if (totals.noData) parts.push(totals.noData + ' senza dati');
                if (totals.unsupportedCountries) {
                    parts.push(totals.unsupportedCountries + ' con paese non supportato');
                }
                showNotice(
                    totals.noData ? 'warning' : 'success',
                    'Aggiornamento completato: ' + (parts.join(', ') || 'nessuna modifica') + '.'
                );
            });
        }

        function refreshSelected() {
            var rows = selectedRows();
            clearSelection();
            refreshRows(rows);
        }

        function refreshOne(row) {
            if (!row) {
                return;
            }
            refreshRows([row]);
        }

        function selectedRows() {
            return vm.rows.filter(function (row) { return row.selected; });
        }

        function selectedCount() {
            return selectedRows().length;
        }

        function selectionChanged() {
            if (vm.moveTargetOptions.length && !vm.selectedCount()) {
                vm.moveTargetId = null;
            }
        }

        function clearSelection() {
            vm.rows.forEach(function (row) {
                row.selected = false;
            });
            vm.moveTargetId = null;
        }

        function allFilteredSelected() {
            return vm.filteredRows.length > 0 && vm.filteredRows.every(function (row) {
                return row.selected;
            });
        }

        function selectAllFiltered() {
            if (allFilteredSelected()) {
                clearSelection();
                return;
            }
            vm.filteredRows.forEach(function (row) {
                row.selected = true;
            });
        }

        function deleteSelected() {
            var rows = selectedRows();
            if (!rows.length || !vm.list) {
                return;
            }
            if (!$window.confirm('Rimuovere ' + rows.length + ' keyword dalla lista?')) {
                return;
            }
            KeywordListService.deleteKeywords(vm.list.id, rows.map(function (row) {
                return row.keywordUuid;
            })).then(function () {
                return loadList(vm.list.id, true);
            }).then(function () {
                showNotice('success', 'Keyword rimosse.');
            }).catch(function (error) {
                showNotice('error', errorMessage(error));
            });
        }

        function deleteOne(row) {
            if (!row) {
                return;
            }
            if (!$window.confirm('Rimuovere "' + row.keyword + '" dalla lista?')) {
                return;
            }
            KeywordListService.deleteKeywords(vm.list.id, [row.keywordUuid])
                .then(function () {
                    return loadList(vm.list.id, true);
                })
                .catch(function (error) {
                    showNotice('error', errorMessage(error));
                });
        }

        function refreshMoveTargets() {
            vm.moveTargetOptions = vm.lists.filter(function (item) {
                return Number(item.keywordListId) !== Number(vm.selectedListId);
            });
        }

        function moveSelected() {
            var rows = selectedRows();
            if (!rows.length || !vm.moveTargetId) {
                return;
            }
            KeywordListService.moveKeywords(
                vm.list.id,
                vm.moveTargetId,
                rows.map(function (row) { return row.id; })
            ).then(function (data) {
                return loadLists(vm.selectedListId);
            }).then(function () {
                showNotice('success', 'Keyword spostate.');
            }).catch(function (error) {
                showNotice('error', errorMessage(error));
            });
        }

        function exportCsv() {
            var rows = selectedRows().length ? selectedRows() : vm.filteredRows;
            if (!rows.length) {
                return;
            }
            var lines = [['Keyword', 'Country', 'Volume', 'CPC', 'Competition', 'KD', 'Updated']];
            rows.forEach(function (row) {
                lines.push([
                    row.keyword,
                    row.countryCode || '',
                    row.avgVolume == null ? '' : row.avgVolume,
                    row.avgCpc == null ? '' : row.avgCpc,
                    row.avgCompetition == null ? '' : row.avgCompetition,
                    row.avgDifficulty == null ? '' : row.avgDifficulty,
                    formatDate(row.updatedAt)
                ]);
            });
            var csv = lines.map(function (cells) {
                return cells.map(function (cell) {
                    return '"' + String(cell == null ? '' : cell).replace(/"/g, '""') + '"';
                }).join(';');
            }).join('\n');
            download('\ufeff' + csv, 'keyword-list.csv', 'text/csv;charset=utf-8;');
        }

        function exportXlsx() {
            var rows = selectedRows().length ? selectedRows() : vm.filteredRows;
            if (!rows.length) {
                return;
            }
            var data = rows.map(function (row) {
                return {
                    Keyword: row.keyword,
                    Country: row.countryCode || '',
                    Volume: row.avgVolume == null ? '' : row.avgVolume,
                    CPC: row.avgCpc == null ? '' : row.avgCpc,
                    Competition: row.avgCompetition == null ? '' : row.avgCompetition,
                    KD: row.avgDifficulty == null ? '' : row.avgDifficulty,
                    Updated: formatDate(row.updatedAt)
                };
            });
            var worksheet = XLSX.utils.json_to_sheet(data);
            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Keywords');
            XLSX.writeFile(workbook, 'keyword-list.xlsx');
        }

        function exportTo(format) {
            vm.exportOpen = false;
            if (format === 'xlsx') {
                exportXlsx();
                return;
            }
            exportCsv();
        }

        function toggleExportMenu() {
            vm.exportOpen = !vm.exportOpen;
        }

        function closeExportMenu(event) {
            var node = event && event.target;
            while (node && node.tagName !== 'DETAILS') {
                node = node.parentNode;
            }
            if (node) {
                node.open = false;
            }
        }

        function copyKeywords() {
            var rows = selectedRows().length ? selectedRows() : vm.filteredRows;
            copyText(rows.map(function (row) { return row.keyword; }).join('\n'), 'Keyword copiate.');
        }

        function download(content, fileName, type) {
            var link = document.createElement('a');
            var blob = new Blob([content], {type: type});
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        }

        function copyText(text, message) {
            if (!$window.navigator.clipboard) {
                showNotice('error', 'Copia non disponibile in questo browser.');
                return;
            }
            $window.navigator.clipboard.writeText(text).then(function () {
                showNotice('success', message);
            }).catch(function () {
                showNotice('error', 'Impossibile copiare.');
            });
        }

        function createList() {
            var name = String(vm.newListName || '').trim();
            if (!name) {
                return;
            }
            KeywordListService.createAKeywordList({name: name, toolSourceId: 1})
                .then(function (response) {
                    var data = bodyData(response) || {};
                    vm.newListName = '';
                    return loadLists(data.keywordListId);
                })
                .catch(function (error) {
                    showNotice('error', errorMessage(error));
                });
        }

        function startRename() {
            vm.renameName = vm.list && vm.list.name || '';
            vm.renaming = true;
        }

        function cancelRename() {
            vm.renaming = false;
            vm.renameName = '';
        }

        function saveRename() {
            var name = String(vm.renameName || '').trim();
            if (!name || !vm.list) {
                return;
            }
            KeywordListService.updateKeywordList(name, vm.list.id)
                .then(function () {
                    vm.renaming = false;
                    return loadLists(vm.list.id);
                })
                .catch(function (error) {
                    showNotice('error', errorMessage(error));
                });
        }

        function deleteList() {
            if (!vm.list) {
                return;
            }
            KeywordListService.deleteKeywordList([vm.list.id])
                .then(function () {
                    vm.confirmDeleteList = false;
                    vm.selectedListId = null;
                    return loadLists();
                })
                .catch(function (error) {
                    showNotice('error', errorMessage(error));
                });
        }

        function cloneList(item, event) {
            if (event) {
                closeListMenu(event);
                event.stopPropagation();
                event.preventDefault();
            }
            var source = item && item.keywordListId ? item : vm.list;
            var sourceId = source && (source.keywordListId || source.id);
            if (!sourceId || vm.cloneBusy[sourceId]) {
                return;
            }
            var cloneName = nextCloneName(source.keywordListName || source.name);
            vm.cloneBusy[sourceId] = true;
            KeywordListService.cloneKeywordList(cloneName, sourceId)
                .then(function (response) {
                    var data = bodyData(response) || {};
                    if (!data.keywordListId) {
                        throw new Error('La lista non è stata duplicata.');
                    }
                    return loadLists(data.keywordListId).then(function () {
                        startInlineEdit({
                            keywordListId: data.keywordListId,
                            keywordListName: cloneName
                        });
                    });
                })
                .catch(function (error) {
                    showNotice('error', errorMessage(error));
                })
                .finally(function () {
                    vm.cloneBusy[sourceId] = false;
                });
        }

        function nextCloneName(name) {
            var base = String(name || 'Lista keyword').trim().slice(0, 230) || 'Lista keyword';
            var index = 1;
            var candidate = base + ' copia ' + index;
            while (vm.lists.some(function (item) {
                return String(item.keywordListName || '').toLowerCase()
                    === candidate.toLowerCase();
            })) {
                index += 1;
                candidate = base + ' copia ' + index;
            }
            return candidate;
        }

        function closeListMenu(event) {
            var node = event && event.target;
            while (node && node.tagName !== 'DETAILS') {
                node = node.parentNode;
            }
            if (node) {
                node.open = false;
            }
        }

        function renameListFromMenu(item, event) {
            closeListMenu(event);
            var id = item && (item.keywordListId || item.id);
            if (!id) {
                return;
            }
            startInlineEdit(item);
        }

        function startInlineEdit(item) {
            var id = item && (item.keywordListId || item.id);
            if (!id) {
                return;
            }
            vm.inlineEdit.id = Number(id);
            vm.inlineEdit.name = String(item.keywordListName || item.name || '');
            vm.inlineEdit.originalName = vm.inlineEdit.name;
        }

        function cancelInlineEdit() {
            vm.inlineEdit.id = null;
            vm.inlineEdit.name = '';
            vm.inlineEdit.originalName = '';
        }

        function saveInlineListName(event) {
            if (event && event.keyCode === 27) {
                cancelInlineEdit();
                return;
            }
            var name = String(vm.inlineEdit.name || '').trim();
            var id = Number(vm.inlineEdit.id);
            if (!name || !id || vm.savingListName) {
                return;
            }
            if (name === vm.inlineEdit.originalName) {
                cancelInlineEdit();
                return;
            }
            vm.savingListName = true;
            KeywordListService.updateKeywordList(name, id)
                .then(function () {
                    vm.lists.forEach(function (item) {
                        if (Number(item.keywordListId) === id) {
                            item.keywordListName = name;
                        }
                    });
                    if (Number(vm.selectedListId) === id && vm.list) {
                        vm.list.name = name;
                    }
                    cancelInlineEdit();
                    applyListFilter();
                    refreshMoveTargets();
                    showNotice('success', 'Nome lista aggiornato.');
                })
                .catch(function (error) {
                    showNotice('error', errorMessage(error));
                })
                .finally(function () {
                    vm.savingListName = false;
                });
        }

        function deleteListFromMenu(item, event) {
            closeListMenu(event);
            var id = item && (item.keywordListId || item.id);
            var name = item && item.keywordListName;
            if (!id || !$window.confirm('Eliminare definitivamente la lista "' + name + '"?')) {
                return;
            }
            KeywordListService.deleteKeywordList([id])
                .then(function () {
                    if (Number(id) === Number(vm.selectedListId)) {
                        vm.selectedListId = null;
                        vm.list = null;
                    }
                    return loadLists();
                })
                .then(function () {
                    showNotice('success', 'Lista eliminata.');
                })
                .catch(function (error) {
                    showNotice('error', errorMessage(error));
                });
        }

        function shareList() {
            if (!vm.list || !vm.list.token) {
                return;
            }
            vm.shareUrl = $window.location.origin
                + '/keyword-list-manager/legacy/shared/' + vm.list.token
                + '?v=' + Date.now().toString(36);
            copyShareUrl();
        }

        function copyShareUrl() {
            if (vm.shareUrl) {
                copyText(vm.shareUrl, 'Link di condivisione copiato.');
            }
        }

        function applyFilters() {
            var term = String(vm.search || '').trim().toLowerCase();
            var countryFilter = String(vm.filters.country || '').toUpperCase();
            var dataFilter = vm.filters.data;
            var rows = vm.rows.filter(function (row) {
                var matchesTerm = !term
                    || String(row.keyword || '').toLowerCase().indexOf(term) !== -1;
                var matchesCountry = !countryFilter
                    || String(row.countryCode || '').toUpperCase() === countryFilter;
                var rowHasData = hasData(row);
                var matchesData = !dataFilter
                    || (dataFilter === 'with' && rowHasData)
                    || (dataFilter === 'without' && !rowHasData);
                return matchesTerm && matchesCountry && matchesData;
            });
            var field = vm.sort.field;
            var direction = vm.sort.dir;
            rows.sort(function (a, b) {
                var left = a[field];
                var right = b[field];
                if (field === 'keyword') {
                    left = String(left || '');
                    right = String(right || '');
                    return left.localeCompare(right) * direction;
                }
                left = left == null ? -Infinity : Number(left);
                right = right == null ? -Infinity : Number(right);
                return (left - right) * direction;
            });
            vm.filteredRows = rows;
            vm.pages = Math.max(1, Math.ceil(rows.length / vm.pageSize));
            vm.page = Math.min(Math.max(vm.page, 1), vm.pages);
            var start = (vm.page - 1) * vm.pageSize;
            vm.pageRows = rows.slice(start, start + vm.pageSize);
        }

        function clearFilters() {
            vm.search = '';
            vm.filters = {country: '', data: ''};
            vm.page = 1;
            applyFilters();
        }

        function activeFiltersCount() {
            var count = 0;
            if (String(vm.search || '').trim()) count += 1;
            if (vm.filters.country) count += 1;
            if (vm.filters.data) count += 1;
            return count;
        }

        function hasActiveFilters() {
            return activeFiltersCount() > 0;
        }

        function setSort(field) {
            if (vm.sort.field === field) {
                vm.sort.dir *= -1;
            } else {
                vm.sort.field = field;
                vm.sort.dir = 1;
            }
            applyFilters();
        }

        function setPage(page) {
            vm.page = Math.min(Math.max(page, 1), vm.pages);
            applyFilters();
        }

        function isPageSelected() {
            return allFilteredSelected();
        }

        function isPageIndeterminate() {
            return vm.filteredRows.some(function (row) {
                return row.selected;
            }) && !isPageSelected();
        }

        function togglePageSelection() {
            selectAllFiltered();
        }

        function formatVolume(value) {
            if (value === null || value === undefined || value === '') {
                return '—';
            }
            return $filter('number')(Number(value), 0);
        }

        function formatMetric(value) {
            if (value === null || value === undefined || value === '') {
                return '—';
            }
            return $filter('number')(Number(value), 0);
        }

        function formatCpc(value) {
            if (value === null || value === undefined || value === '') {
                return '—';
            }
            return $filter('number')(Number(value), 2);
        }

        function formatDate(value) {
            if (!value) {
                return '—';
            }
            var date = new Date(value);
            return isNaN(date.getTime()) ? '—' : $filter('date')(date, 'dd/MM/yyyy');
        }

        function kdClass(value) {
            var score = Number(value);
            if (!score) return 'is-empty';
            if (score >= 70) return 'is-high';
            if (score >= 30) return 'is-mid';
            return 'is-low';
        }

        function hasData(row) {
            return Number(row.avgVolume) > 0
                || Number(row.avgCpc) > 0
                || Number(row.avgCompetition) > 0;
        }

        function hasMetric(value) {
            return value !== null && value !== undefined && value !== '';
        }
    }

    Controller.$inject = [
        '$scope',
        '$q',
        '$timeout',
        '$filter',
        '$window',
        '$state',
        '$stateParams',
        'KeywordListService',
        'UserService',
        'LanguageService'
    ];
    return Controller;
});
